import createFetchTypes from '@app/utils/createFetchTypes';
import {
	PrebuiltCampaignSiblingType,
	PrebuiltCampaignType,
} from '@app/types/modules/prebuiltCampaign';

export type { PrebuiltCampaignSiblingType, PrebuiltCampaignType };

const mainType = 'prebuiltCampaign';

export const getPrebuiltCampaignsTypes = createFetchTypes(
	`${mainType}_GET_PREBUILT_CAMPAIGNS`,
);
